import React from 'react';
import { injectIntl } from 'react-intl';
import Button from 's2s-button';
import AppMenu from './app-menu';
import styled from 'styled-components';
import { getIntlText } from '../js/utilities';
import PropTypes from 'prop-types';
import { track } from 's2s-app-service';
import useAuth from "../hooks/auth";
import { colorGrid } from 's2s-themes';

const HeaderContainer = styled.div`
  align-items: center;
  background-color: #243991;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-height: 48px;
  min-width: 320px;
  padding: 0px;
`;

const HeaderButton = styled(Button)`
  padding-left : 0px;
  padding-right : 0px;
  background-color: transparent;
  width: 32px;
  justify-content: center;
  margin-left: 12px;
  
  :hover {
    background-color: #182661;
  }
`;

const RightContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  width: 100%;
`;

const Header = (props) => {
  const [auth] = useAuth();

  const renderRouteButton = () => {
    if (props.location.pathname.indexOf('/contact') === 0) {
      // we are on a ContactList or ContactDetails route
      // display a button that will go back to previous route
      // console.log('show back arrow');
      return (
        <HeaderButton
          ariaLabel={getIntlText(props.intl, 'HEADER-BACK-ARIA-LABEL', "back")}
          cbClick={() => {
            props.cbChangeRoute("back");
          }}
          svgFill="#fff"
          svgType="ChevronLeftIconSVG"
        />);
    } else if (props.location.pathname.indexOf('/login') !== -1 ||
      (props.location.pathname.indexOf('/') !== -1 && props.location.pathname.length === 1) ||
      props.location.pathname.indexOf('/forgotpw') !== -1 ||
      props.location.pathname.indexOf('/changepwd') !== -1) {
      // Don't show if not authenticated
      // console.log('dont show nuthin for header...not authenticated');
      return undefined;
    } else {
      // show contact button
      // console.log('show contact button');
      return (
        <HeaderButton
          ariaLabel={getIntlText(props.intl, `HEADER-CONTACTS-ARIA-LABEL`, "contact list")}
          isDisabled={!auth.isOnline}
          cbClick={() => {
            track("header_open_contactlist", "clicked");
            props.cbChangeRoute("contactlist");
          }}
          svgFill="#fff"
          svgType="MdContacts"
        />
      );
    }
  };

  // console.log('STATUS --->', props.status);
  return (
    <HeaderContainer className="headerContainer">
      {renderRouteButton()}
      <RightContainer className="rightContainer">
        <AppMenu
          cbHelpClick={() => {
            
            // Help Documentation Link, until the help page is ready
            const helpLink = 'https://knowledge.star2star.com/kb/1650';
            if (typeof (window.openHelp) == 'function') {
              // NOTE - for electron, need to specify full path, so prepend location.origin
              track("header_open_help", "clicked");

              window.openHelp(helpLink);
              // window.openHelp(`${window.location.origin}${"/help"}`);
            } else {
              track("header_open_help", "clicked");

              window.open(helpLink);
              // window.open("/help");
            }
          }}
          cbSettingsClick={() => {
            if (!props.location.pathname.includes('settings')) {
              track("header_open_settings", "clicked");
              props.history.push('/settings');
            }
          }}
          cbStatusClick={() => {
            // console.log("status clicking");
          }}
          status={props.status}
          availableExtensions={props.availableExtensions}
        />
      </RightContainer>
    </HeaderContainer>
  );

};

Header.propTypes = {
  availableExtensions: PropTypes.array,
  cbChangeRoute: PropTypes.func,
  cbHelpClick: PropTypes.func,
  cbRefreshDevices: PropTypes.func,
  cbSettingsChanged: PropTypes.func,
  cbSettingsClosing: PropTypes.func,
  status: PropTypes.string,
  intl: PropTypes.object,
  children: PropTypes.array,
  location: PropTypes.object,
};


export default injectIntl(Header);
